import { createService } from '@bonanza-social/toolkit/api';
import { InitOnfidoSchema, ProcessOnfidoSchema } from './KYCService.schemas';

export default createService(
  {
    initOnfido: {
      method: 'POST',
      url: '/onfidoInit',
      responseSchema: InitOnfidoSchema,
    },
    processOnfido: {
      method: 'POST',
      url: '/onfidoProcessing',
      responseSchema: ProcessOnfidoSchema,
    },
  },
  ({ userId }) => `/kyc/${userId}`,
);
